function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "Delete ",
        "?"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "Delete ",
        "?"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Are you sure you want to delete ",
        "? ",
        " This action cannot be undone."
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "Are you sure you want to delete ",
        "? This action cannot be undone."
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "Yes, Delete"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
import { Typography } from "antd";
import React from "react";
import { t, jt } from "ttag";
import Modal from ".";
var Text = Typography.Text;
var getCustomTitle = function(count, label) {
    return count > 1 && label.plural ? t(_templateObject(), label.plural) : t(_templateObject1(), label.singular);
};
var CustomLabel = function(param) {
    var count = param.count, itemLabel = param.itemLabel;
    if (count > 1) {
        return /*#__PURE__*/ React.createElement(Text, null, count, " ", itemLabel);
    }
    return /*#__PURE__*/ React.createElement(Text, {
        strong: true
    }, itemLabel);
};
var Content = function(param) {
    var itemLabel = param.itemLabel, count = param.count, _param_additionalInfo = param.additionalInfo, additionalInfo = _param_additionalInfo === void 0 ? null : _param_additionalInfo;
    var customLabel = /*#__PURE__*/ React.createElement(CustomLabel, {
        key: "itemLabel",
        count: count,
        itemLabel: itemLabel
    });
    return /*#__PURE__*/ React.createElement(Text, null, additionalInfo ? jt(_templateObject2(), customLabel, additionalInfo) : jt(_templateObject3(), customLabel));
};
var confirm = function(param) {
    var title = param.title, label = param.label, itemName = param.itemName, count = param.count, additionalInfo = param.additionalInfo, content = param.content, onDelete = param.onDelete, onCancel = param.onCancel, okText = param.okText, cancelText = param.cancelText, confirmDisabled = param.confirmDisabled;
    return Modal.confirm({
        title: title !== null && title !== void 0 ? title : getCustomTitle(count, label),
        content: content !== null && content !== void 0 ? content : /*#__PURE__*/ React.createElement(Content, {
            itemLabel: count > 1 ? label.plural : itemName,
            count: count,
            additionalInfo: additionalInfo
        }),
        cancelText: cancelText,
        okText: okText !== null && okText !== void 0 ? okText : t(_templateObject4()),
        confirmDisabled: confirmDisabled,
        onOk: onDelete,
        onCancel: onCancel
    });
};
var DeleteModal = {
    confirm: confirm
};
export default DeleteModal;
